<template>
  <div class="search">
    <div class="classForClickOutside" @click="setIsSearchDropDownVisible(false)"></div>

    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar" @keyup.down="hoverDown" @keyup.up="hoverUp">
      <label for="search-bar-input-board" class="blind">검색창</label>
      <input
        id="search-bar-input-board"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="게시글 검색"
        v-on:input="typing"
        @focus="setIsSearchDropDownVisible(true)"
        v-model="searchString"
        v-on:keyup.enter="enterSearch"
      />

      <button class="search-button" type="button" @click="search('')" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <div class="search-dropdown" v-show="isSearchDropDownVisible && searchString">
      <ul class="search-dropdown__menu">
        <li
          v-show="searchString"
          v-for="(searchBoxInfo, index) in searchBoxInfoList"
          :key="index"
          :class="activeIndex === index ? 'active' : null"
          @mouseover="setActiveIndex(index)"
        >
          <a class="search-dropdown__menu--row" @click="searchBoxInfo.clickFunc"
            >{{ searchBoxInfo.searchName }}: <span class="bold">{{ searchString }}</span></a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardSearchBox',
  data() {
    return {
      keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
      searchString: '',
      isSearchComplete: false,
      defaultInfo: {},
      fkBoardInfoNo: null,
      activeIndex: -1,
      searchBoxInfoList: [
        {
          searchName: '제목',
          clickFunc: () => this.search('title'),
        },
        {
          searchName: '내용',
          clickFunc: () => this.search('content'),
        },
        {
          searchName: '작성자',
          clickFunc: () => this.search('writer'),
        },
      ],
    };
  },
  props: {
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.init();
    this.$forceUpdate();
  },
  methods: {
    hoverUp() {
      if (this.activeIndex <= 0) {
        return false;
      }
      this.activeIndex--;
    },
    hoverDown() {
      if (this.activeIndex >= this.searchBoxInfoList.length - 1) {
        return false;
      }
      this.activeIndex++;
    },
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    init() {
      let self = this;
      if (window.location.hash !== '') {
        setTimeout(() => {
          this.$emit('set-is-search-drop-down-visible', false);
          self.defaultInfo = self.getHashObject(window.location.hash);
          self.fkBoardInfoNo = window.defalutInfo.LIST.fk_board_info_no;
          self.searchString = self.defaultInfo.searchWord;
          self.isSearchComplete = self.searchString.length <= 0 ? false : true;
        }, 1000);
      }
    },
    typing(event) {
      this.searchString = event.target.value;
      if (!this.isSearchDropDownVisible) {
        this.$emit('set-is-search-drop-down-visible', true);
      }
    },
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    enterSearch() {
      if (this.activeIndex <= -1) {
        this.searchBoxInfoList[0].clickFunc();
      } else {
        this.searchBoxInfoList[this.activeIndex].clickFunc();
      }
    },
    search(type) {
      this.setIsSearchDropDownVisible(false);

      this.defaultInfo.searchWord = this.searchString;
      this.defaultInfo.searchWordFlag = type;

      let tmp_str = '';
      for (const [key, value] of Object.entries(this.defaultInfo)) {
        tmp_str += key + '=' + value + '&';
      }
      tmp_str = this.encode(tmp_str);

      document.location.hash = tmp_str;
      document.location.reload();
    },
    openDetailSearch() {
      this.setIsSearchDropDownVisible(false);
    },
    cancelSearch() {
      window.location.hash = '';
      window.location.reload();
    },
    encode(input) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;

      input = this._utf8_encode(input);

      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output =
          output +
          this.keyStr.charAt(enc1) +
          this.keyStr.charAt(enc2) +
          this.keyStr.charAt(enc3) +
          this.keyStr.charAt(enc4);
      }

      return output;
    },

    _utf8_encode: function(string) {
      string = string.replace(/\r\n/g, '\n');
      var utftext = '';

      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);

        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }

      return utftext;
    },
    _utf8_decode: function(utftext) {
      let string = '';
      let i = 0;
      let c = 0,
        c2,
        c3 = 0;

      while (i < utftext.length) {
        c = utftext.charCodeAt(i);

        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if (c > 191 && c < 224) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    permitObjectValueName: function(str) {
      // 원치 않는 값이 들어가지 못하게 막는다
      let permitArr = [
        'currentPage',
        'itemsPerPage',
        'searchWord',
        'searchWordFlag',
        'rangeSize',
        'totalPage',
        'totalCount',
        'fk_board_info_no',
        'ordering',
        'order_condition',
        'myContents',
        'beginning_wd',
        'importants_flag',
      ];
      return permitArr.includes(str);
    },
    getHashObject: function(hash_string) {
      let vars = new Object();
      let hash;
      let hashes = this.decode(hash_string).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');

        if (this.permitObjectValueName(hash[0])) vars[hash[0]] = hash[1];
      }
      return vars;
    },
    decode: function(input) {
      let output = '';
      let chr1, chr2, chr3;
      let enc1, enc2, enc3, enc4;
      let i = 0;

      input = input.replace(/[^A-Za-z0-9+/=]/g, '');

      while (i < input.length) {
        enc1 = this.keyStr.indexOf(input.charAt(i++));
        enc2 = this.keyStr.indexOf(input.charAt(i++));
        enc3 = this.keyStr.indexOf(input.charAt(i++));
        enc4 = this.keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }

      output = this._utf8_decode(output);

      return output;
    },
  },
};
</script>
